<template lang="html">
   <div style="background: black; width: 100vw;height: 100vh;">

</div>
</template>

<script>

export default {
  data: () => ({
    
  }),
  mounted () {
    this.chatbox()
  },
  computed: {
  },
  methods: {
    chatbox () {
      var div_chatbot = document.createElement('div')
      document.getElementsByTagName('body')[0].appendChild(div_chatbot)
      div_chatbot.outerHTML = "<div id='botChat' style='border-top-left-radius: 10px; border-top-right-radius: 10px; position: absolute;margin-top: 0px; margin-right: 0px; margin-bottom: 0px; padding: 0px; border: 0px; background: transparent; overflow: hidden; position: fixed; z-index: 16000004; right: 10px; bottom: 0px;display: none; width: 300px; height: 500px; box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 3px 2px;'><div id='botTitleBar' style='z-index: 16000005;height: 27px; width: 290px; position:fixed; cursor: pointer; border-top-left-radius: 10px; border-top-right-radius: 10px;'></div><iframe frameborder='0' style='background-color: transparent; vertical-align: text-bottom; position: relative; width: 100%; height: 100%; min-width: 100%; min-height: 100%; max-width: 100%; max-height: 100%; margin: 0px; overflow: hidden; display: block;'src='https://oss.korkla.in/register/oss'></iframe></div><div id='minBotChat' style='border-radius: 10px;margin-top: 0px; margin-right: 0px; margin-bottom: 0px; padding: 0px; border: 0px; background: transparent;position: fixed; z-index: 16000002; width: 180px; height: 30px; right: 10px; bottom: 15px;'><div id='minBotChatTitle' style='z-index: 16000003;height: 30px; width: 180px; position:fixed; cursor: pointer;'></div><iframe frameborder='0' style='background-color: transparent; vertical-align: text-bottom; position: relative; width: 100%; height: 100%; min-width: 100%; min-height: 100%; max-width: 100%; max-height: 100%; margin: 0px; overflow: hidden; display: block;' src='https://oss.korkla.in/minchat/oss'></iframe></div>"

      document.querySelector('body').addEventListener('click', function (e) {
          e.target.matches = e.target.matches || e.target.msMatchesSelector
          if (e.target.matches('#botTitleBar')) {
            document.getElementById("botChat").style.display = "none"
            document.getElementById("minBotChat").style.display = "block"
          } else if (e.target.matches('#minBotChatTitle')) {
            document.getElementById("botChat").style.display = "block"
            document.getElementById("minBotChat").style.display = "none"
          }
      })
    }

  },
  created () {
    
  }
}
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/showtest.vue